import { render, staticRenderFns } from "./Inquary.vue?vue&type=template&id=488c9ea2&"
import script from "./Inquary.vue?vue&type=script&lang=js&"
export * from "./Inquary.vue?vue&type=script&lang=js&"
import style0 from "./Inquary.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports